module.exports = __webpack_public_path__ + "static/media/w (7).77f6def3.jpg";